import { BoltDriveFlexProps } from './types'
import { Header, HeadingAndContent, List, TextAndMedia } from '@boltenergy-be/design-system'
import EvDiscountForm from './components/ev-discount-form/EvDiscountForm'
import FaqWithDefaultDescription from 'components/faq-with-default-description/FaqWithDefaultDescription'
import { useTranslation } from 'next-i18next/pages'
import styles from './BoltDriveFlex.module.scss'
import BoltOffering from 'sections/bolt-offering/BoltOffering'
import StartSimulationSection from 'sections/start-simulation/StartSimulationSection'

const BoltDriveFlex = ({ faqCategories, extraStartSimulationAction }: BoltDriveFlexProps) => {
  // i18n
  const { t } = useTranslation(['electricVehicles', 'common'])

  return (
    <main>
      <Header title={t('hero.title')} shape="s3">
        <p className={styles.description}>{t('hero.description')}</p>
      </Header>

      <TextAndMedia
        title={t('howItWorks.title')}
        media={{
          type: 'image',
          props: { publicId: 'website/ev-flex/ev-load', fill: true, alt: t('howItWorks.alt'), className: styles['about-image'] }
        }}
      >
        <p>{t('howItWorks.description')}</p>
      </TextAndMedia>

      <EvDiscountForm />

      <HeadingAndContent inset color="accent-warm" title={t('advantages.title')}>
        <List as="ul" bullets="badgeCheck">
          {(t('advantages.list', { returnObjects: true }) as string[]).map((text, index) => (
            <li key={`advantage-${index}`}>{text}</li>
          ))}
        </List>
      </HeadingAndContent>

      <StartSimulationSection onSubmitExtraActions={extraStartSimulationAction} containerClassName="pt-none" />

      <BoltOffering />

      <FaqWithDefaultDescription title={t('faq.title')} categories={faqCategories} />
    </main>
  )
}

export default BoltDriveFlex
